import type { LeadActivityVoicemailDrop } from "views/leads-id/types";

// CRM-1830: a pre-recorded voicemail a teammate left on an outgoing call, as
// the lead's activity log and the Inbox timeline name it. Worded so it never
// reads as a voicemail the lead left for the team.

// "0:24". Rounded once, so 59.6 s reads 1:00, not 0:00.
export const formatVoicemailClock = (seconds: number) => {
  const total = Math.max(0, Math.round(seconds));
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
};

const messageName = (drop: LeadActivityVoicemailDrop) =>
  drop.voicemail_deleted ? `${drop.name} (deleted)` : drop.name;

// "Voicemail left: First outreach", or
// "Voicemail not finished: First outreach (0:08 of 0:24)".
export const describeVoicemailDrop = (drop: LeadActivityVoicemailDrop) =>
  drop.status === "not_finished"
    ? `Voicemail not finished: ${messageName(drop)} (${formatVoicemailClock(drop.played_seconds ?? 0)} of ${formatVoicemailClock(drop.duration_seconds)})`
    : `Voicemail left: ${messageName(drop)}`;
